import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { useCloseTemplates } from "@api/closeTemplate.api";

interface Props {
    filters: FiltersTypes;
}

export const CloseTemplateFilterLabel: React.FC<Props> = ({ filters }) => {
    const { data: templates = [] } = useCloseTemplates();
    const { closeTemplateIds } = filters;

    const selectedNames = useMemo(
        () =>
            templates
                .filter((t) => closeTemplateIds?.includes(t.id))
                .map((t) => t.name),
        [templates, closeTemplateIds],
    );

    if (selectedNames.length === 0) {
        return null;
    }

    if (selectedNames.length === 1) {
        return <span>{selectedNames[0]}</span>;
    }

    return <span>{selectedNames.length} service templates</span>;
};
